import { render, staticRenderFns } from "./DepartmentName.vue?vue&type=template&id=50e72f9e&scoped=true&"
import script from "./DepartmentName.vue?vue&type=script&lang=js&"
export * from "./DepartmentName.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentName.vue?vue&type=style&index=0&id=50e72f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e72f9e",
  null
  
)

export default component.exports